import { createNode, PlainDateDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromPlainDate } from '../../utils/temporal';

export const NowDate = createNode({
    id: 'Now (Date)',
    name: 'Now (Date)',
    description: 'Returns the current date, optionally in a specific timezone',
    aiDescription:
        'Takes an optional timezone string on the "Timezone" port and outputs the current Date on the "Date" port. Defaults to the system timezone.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Timezone: { kind: 'string' },
    },
    optionalInPorts: ['Timezone'],
    outPorts: {
        Date: PlainDateDataType,
    },
    execute: function (input) {
        const timezone = input.inPorts.Timezone ?? Temporal.Now.timeZoneId();
        const date = Temporal.Now.plainDateISO(timezone);
        return { output: { Date: fromPlainDate(date) } };
    },
});
